export default "__VITE_ASSET__BzoHIQB8__"